import instance from "./instance";

export const getProfile = async () => {
  const res = await instance.get('/profile/');
  return res.data;
};

export const changePassword = async (old_password, new_password) => {
  try {
    await instance.post('/profile/change-password/', {
      old_password,
      new_password,
    });
    return { success: true };
  } catch (error) {
    const err = error?.response?.data;
    return {
      success: false,
      message: err?.old_password
        ? `Ошибка старого пароля: ${err.old_password}`
        : 'Не удалось изменить пароль.',
    };
  }
};

export const updateProfile = async (username, email) => {
  try {
    await instance.patch('/profile/update/', { username, email });
    return {
      success: true,
    };
  } catch (error) {
    const err = error?.response?.data;
    return {
      success: false,
      message: err?.email
        ? `Ошибка email: ${err.email}`
        : 'Не удалось обновить профиль.',
    };
  }
};
